import React from 'react';
import { ErrorMessage } from 'formik';
import classNames from 'classnames';
import LabelR from '../../Simple/LabelR';

const TextArea = (props) => {
  const {
    field: { name, value, onChange, onBlur },
    form: { touched = [], errors = [] },
    label,
    placeholder,
    disabled = false,
    required,
    requiredFields = [name],
    rows,
    showError,
    className,
    maxLength,
  } = props;

  const classes = classNames('form-control', { 'is-invalid': (errors[name] && touched[name]) || showError }, className);
  return (
    <div className="form-group" id={`${name}-container-textarea`}>
      {label &&
        (required ? (
          <LabelR requiredFields={requiredFields} isEditable={!disabled} htmlFor={name}>
            {label}
          </LabelR>
        ) : (
          <label htmlFor={name}>{label}</label>
        ))}
      <textarea
        rows={rows}
        name={name}
        id={`${name}-textarea`}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        className={classes}
        placeholder={placeholder}
        disabled={disabled}
        maxLength={maxLength}
      />
      {touched[name] && errors[name] && <ErrorMessage name={name} component="div" className="invalid-feedback" />}
    </div>
  );
};

export default TextArea;
